export function getRequiredResponseValue(data, key) {
  const value = data?.[key];
  if (value === undefined || value === null || value === "") {
    throw new Error(`Missing ${key}`);
  }
  return value;
}

export function buildShareUrl(baseUrl, segments) {
  const missingSegment = segments.some((segment) => segment === undefined || segment === null || segment === "");
  if (missingSegment) {
    throw new Error("Missing gift share value");
  }

  const normalizedBase = String(baseUrl || "").replace(/\/+$/, "");
  const normalizedPath = segments
    .map((segment) => encodeURIComponent(String(segment)).replace(/%2F/g, "/"))
    .join("/");

  return `${normalizedBase}/${normalizedPath}/`;
}

export function canInvokeKakaoShare(windowRef = globalThis.window) {
  return typeof windowRef?.Kakao?.Share?.sendDefault === "function";
}

export function isGiftSendSuccess(data) {
  return data?.result === "ok" || data?.status === "ok";
}

export function normalizeGiftPhoneNumber(value) {
  const digits = String(value || "").replace(/\D/g, "");
  return /^010\d{8}$/.test(digits) ? digits : null;
}

export function getGiftSendErrorMessage(error, fallback = "전송 실패") {
  const data = error?.response?.data;
  if (typeof data?.error === "string" && data.error.trim()) {
    const errorMessage = data.error.trim();
    if (errorMessage === "gift obj allready exists. re-gifting is not allowed!") {
      return "이미 생성된 선물 링크가 있습니다. 공유 링크를 다시 확인해 주세요.";
    }
    return errorMessage;
  }
  if (typeof data?.message === "string" && data.message.trim()) {
    return data.message.trim();
  }
  if (typeof error?.message === "string" && error.message.trim()) {
    return error.message.trim();
  }
  return fallback;
}
